import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'retailer_pos-shopify_reorder_link_product-click';

/**
 * User clicked a reorder link from their Shopify dashboard
 */
export function trackRetailerPosShopifyReorderLinkProductClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
